<template>
   <div class="amd">

      <ViewCard v-for="(value,index) in data" :key="index" :data="value" title="Software y Diseño" tipo="AMD" />
   </div>
</template>

<script>
   import ViewCard from "../components/ViewCard";
   import {mapState, mapMutations, mapActions} from 'vuex'

   export default {
      name: "Ryzen",
      components: {ViewCard},
       computed: mapState([
           'data',
       ]),
   }
</script>

<style scoped lang="scss">
   @import "../style/base";

</style>